import config from '@/config';
import { requests } from '.';
const baseUrl = config.BASE_URL;
export const ChatWidgetServices = {
    getChatWidgets: (locationId, params) => requests(baseUrl).get(`/chat-widget/list?locationId=${locationId}`, {
        params,
    }),
    createChatWidget: (data) => requests(baseUrl).post(`/chat-widget/`, data),
    getChatWidget: (locationId, chatWidgetId) => requests(baseUrl).get(`/chat-widget/data/${locationId}/${chatWidgetId}`),
    deleteChatWidget: (locationId, chatWidgetId) => requests(baseUrl).delete(`/chat-widget/${locationId}/${chatWidgetId}`),
    cloneChatWidget: (data) => requests(baseUrl).post(`/chat-widget/clone`, data),
    updateChatWidget: (locationId, chatWidgetId, data) => requests(baseUrl).put(`/chat-widget/data/${locationId}/${chatWidgetId}`, data),
    getCode: ({ locationId, isGTM = false, widgetId, }) => {
        const params = {
            isGTM,
        };
        if (widgetId)
            params.widgetId = widgetId;
        return requests(baseUrl).get(`/chat-widget/code/${locationId}`, { params });
    },
};
